import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("mc_user") || "null"); } catch { return null; }
  });
  const [workspace, setWorkspace] = useState(() => {
    try { return JSON.parse(localStorage.getItem("mc_workspace") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  const persist = useCallback((token, u, w) => {
    if (token) localStorage.setItem("mc_token", token);
    if (u) localStorage.setItem("mc_user", JSON.stringify(u));
    if (w) localStorage.setItem("mc_workspace", JSON.stringify(w));
    setUser(u || null);
    setWorkspace(w || null);
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    persist(res.data.token, res.data.user, res.data.workspace);
    return res.data;
  };

  const register = async (data) => {
    const res = await api.post("/auth/register", data);
    persist(res.data.token, res.data.user, res.data.workspace);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("mc_token");
    localStorage.removeItem("mc_user");
    localStorage.removeItem("mc_workspace");
    setUser(null);
    setWorkspace(null);
  };

  const refreshWorkspace = useCallback(async () => {
    const token = localStorage.getItem("mc_token");
    if (!token) return null;
    try {
      const res = await api.get("/auth/me");
      persist(token, res.data.user, res.data.workspace);
      return res.data.workspace;
    } catch { return null; }
  }, [persist]);

  useEffect(() => {
    let active = true;
    const token = localStorage.getItem("mc_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((res) => {
        if (!active) return;
        persist(token, res.data.user, res.data.workspace);
      })
      .catch(() => active && logout())
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [persist]);

  return (
    <AuthContext.Provider value={{ user, workspace, loading, login, register, logout, refreshWorkspace }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
